import React, { createContext, useState, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('isDarkMode');
    return saved !== null ? JSON.parse(saved) : false;
  });

  useEffect(() => {
    localStorage.setItem('isDarkMode', JSON.stringify(isDarkMode));
    // Aplicar el tema al elemento raíz del DOM — activa las variables CSS automáticamente
    if (isDarkMode) {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
  }, [isDarkMode]);

  const toggleTheme = () => setIsDarkMode(prev => !prev);

  // Mantener el objeto theme por compatibilidad con componentes que aún lo usan via props
  const theme = {
    isDarkMode,
    bg: isDarkMode ? '#0d1526' : '#f8fafc',
    card: isDarkMode ? '#1a2035' : '#ffffff',
    text: isDarkMode ? '#e2e8f0' : '#1e293b',
    title: isDarkMode ? '#f1f5f9' : '#0f172a',
    border: isDarkMode ? '#2d3a52' : '#e2e8f0',
    subtext: isDarkMode ? '#9ca3af' : '#64748b',
    sidebar: isDarkMode ? '#111827' : '#ffffff',
    sidebarBorder: isDarkMode ? '#1f2937' : '#e2e8f0',
    inputBg: isDarkMode ? '#0d1526' : '#f1f5f9',
    inputBorder: isDarkMode ? '#2d3a52' : '#cbd5e1',
    modalOverlay: 'rgba(0,0,0,0.6)',
  };

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme, theme }}>
      {children}
    </ThemeContext.Provider>
  );
};
